import { ChevronRightSolid, CircleQuestionSolid } from '@allocab/allocab-icons';
import { TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useState } from 'react';

import { HelpModal } from './HelpModal';
import { t } from '../../services/translation/translation';

type Props = {
  trip: TripOutput;
  anonymous: boolean;
};

export const TripHelp = ({ trip, anonymous }: Props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <div
        className="flex items-center h-16 justify-center px-2 cursor-pointer mt-2"
        onClick={() => setIsModalVisible(true)}
      >
        <div className="bg-primary/10 w-12 h-12 flex items-center justify-center">
          <CircleQuestionSolid height={20} width={20} className="fill-primary" />
        </div>
        <div className="flex-1 mx-2">
          <p className="font-bold text-base">{t('help-details-modal.title')}</p>
        </div>
        <ChevronRightSolid height={16} width={16} />
      </div>
      {isModalVisible ? <HelpModal anonymous={anonymous} trip={trip} onClose={() => setIsModalVisible(false)} /> : null}
    </>
  );
};
